import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Switch, Text, Tooltip } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

interface StickyToggleProps {
    active: boolean;
    onChange: (enabled: boolean) => void;
    hasBaseline: boolean;
}

export const StickyToggle = ({
    active,
    onChange,
    hasBaseline,
}: StickyToggleProps) => {
    const { t } = useTranslation('facetingPanel');

    return (
        <Flex
            align='center'
            justify='between'
            p='2'
            mb='2'
            style={{
                backgroundColor: 'var(--gray-2)',
                borderRadius: 'var(--radius-2)',
                border: '1px solid var(--gray-4)',
            }}
            asChild
        >
            <Text size='1' weight='bold' as='label'>
                <Flex align='center' gap='2'>
                    {t('globalContext.label')}
                    <Tooltip content={t('globalContext.tooltip')}>
                        <InfoCircledIcon color='var(--gray-8)' />
                    </Tooltip>
                </Flex>

                <Switch
                    size='1'
                    checked={active}
                    onCheckedChange={onChange}
                    disabled={!hasBaseline}
                />
            </Text>
        </Flex>
    );
};
